export default __webpack_public_path__ + "static/media/img-proj-cross_procurement.dc2c7382.jpeg";